import axiosInstance from '../axiosInstance';
import { BaseService } from './baseService';

class InboundMessagesService extends BaseService<
	InboundMessage,
	'inboundMessagesID',
	'inboundMessages'
> {
	constructor() {
		super('inboundMessagesID', 'inboundMessage', 'inboundMessages');
	}

	async export(filters: string) {
		return axiosInstance.get(`/app/inboundMessages/export?${filters}`, {
			responseType: 'blob',
		});
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new InboundMessagesService();
